export default __webpack_public_path__ + "static/media/optimism-disable.5763595b.svg";